import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FontsService {

  selectedFont: string = 'Arial, sans-serif';

  constructor( private http: HttpClient ) { }

  setSelectedFont(fontFamily: string) {
    this.selectedFont = fontFamily;
  }
    private apiKey = environment.URL_MAPPING.GOOGLE_FONTS_API_KEY; 
    private apiUrl = 'https://www.googleapis.com/webfonts/v1/webfonts';

    getFontStyles(): Observable<any> {
      const url = `${this.apiUrl}?key=${this.apiKey}`;
      return this.http.get(url);
    }
}
